function myGhostClick(canvas_size,img_objs,on_load,options){
//    img_objs={url:"",left:0,top:0}
    var c = document.createElement('canvas');
    c.width=canvas_size[0];
    c.height=canvas_size[1];
    
    this.ctx=c.getContext("2d");
    this.width=canvas_size[0];
    this.height=canvas_size[1];
    
    
    this.img_objs={};
    var name,bum,imgArr=[];
    for(name in img_objs){
        bum=img_objs[name];
        this.img_objs[name]=copyObj(bum);
        imgArr.push(bum.url);
    }
    var c_this=this;
    $("<div/>").one("myload",function(){
        for(name in c_this.img_objs){
            c_this.img_objs[name].img=new Image();
            c_this.img_objs[name].img.src=c_this.img_objs[name].url;
        }
        on_load();
    }).myLoad(imgArr);
}
myGhostClick.prototype={
    takeImage:function(x,y){
        var name,bum;
        this.ctx.clearRect(0, 0, this.width, this.height);
        for(name in this.img_objs){
            bum=this.img_objs[name];
            
            this.ctx.drawImage(bum.img, bum.left, bum.top,bum.img.width,bum.img.height);
            
            var imageData = this.ctx.getImageData(0, 0, this.width, this.height);
            var pixel_start=4*(this.width*y+x);
            if(imageData.data[pixel_start+3]!=0){
                return name;
            }
    
        }
        return false;
    }
};


